import React, { memo, Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Swal from "sweetalert2";

import { SiteRutas, ImagenesRutas } from "../../request/RutasConfig";
import Config from '../../components/Util/Constantes';
import { toDDHHMMSS, Retorna_Nombre_Estado_Orden, AUTHORIZE_TYPES } from '../../components/Util/Util.js';
import MonitorSucursalInt from "./Interfaz/monitorSucursalInt.jsx";
import DespacharOrdenes from "./Interfaz/despacharOrdenes.jsx";
import ImprimeDespacho from './Interfaz/imprimir/imprimeDespacho.jsx';
import ModalSeguridad from "../Seguridad/ModalSeguridad.jsx";
import ModalValidarLotes from '../../components/Body/Lotes/ModalValidarLotes.jsx';
import {
    Exp_Orden_Encabezado_Par_Detalle, Listar_ParametrosGenerales, Listar_ParametrosCadena, AnalisisTiempoOrden_Listar, Exp_Validar_Despacho_Orden_Ecommerce
} from "../../request/ProcesosRequest";
import {
    Ordenes_Muestra_Despacho_RO, Listar_Ordenes_A_Pantalla, Exp_Despachar_Orden_Ecommerce, Exp_Orden_Encabezado_Par_Imprime, Verifica_Movimientos_Aplicados_Orden,
    Eliminar_Orden_Completo_Orden, SubOrdenes_Muestra_Despacho_RO, ExpSuborden_Encabezado_Par_Listar, Movimiento_Inventario, Obtener_Autorizador_Tarjeta
} from "../../request/MonitorSucursalRequest";
import { Obtener_Estado_Active_Directory_Request } from '../../request/ParametroRequest';
import { Obtener_SubOrden_Detalles_Lote_Request, Agregar_SubOrden_Detalles_Lote_Request, Obtener_Conexion_Lote_Request, Eliminar_SubOrden_Detalles_Lote_Por_Articulo_Request, Agregar_Inventario_Detalles_Lote_Request } from '../../request/LotesRequest';
import { ObtieneParametroSucursal } from '../../request/ParametroRequest';
import { ParametroCallCenter_Detalle, Tiempos_Lista } from "../../request/MantenimientosRequest";
import { Actualizar_Bitacora_Credomatic_Request, Registrar_Bitacora_Credomatic_Request } from '../../request/BitacoraRequest';
import { Obtener_Pago_Referencias_Tarjetas } from '../../request/OrdenPagoRequest';
import { Obtener_MenuOpciones } from "../../request/MenuRequest";
import { ReversalFACRequest } from '../../request/FACPG2Request';
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import LocalStorage from '../../components/Util/LocalStorage/LocalStorage';

import LotesComponent from '@logicaldatacr/ld.lotes.web';
import '@logicaldatacr/ld.lotes.web/dist/index.css';


const localStorageObject = new LocalStorage();

class MonitorSucursales extends Component {
    timer = null;
    _isMounted = false;

    state = {
        activoAD: false,
        fecha_activa: [new Date(), new Date()],
        listaOrdenes: [],
        listaOrdenesFiltradas: [],
        listaSubOrdenes: [],
        estadoOrdenes: '',
        ControlMonitoreo: {},
        ParamCallCenter: {},
        ordenUbicacion: {
            Fecha: '', Orden: '', Estado: '', Disponible: '', Telefono: '', Nombre: '', coordenada: '', Ubicacion: '', Localidad: '', Observaciones: '', Peso: '', Cubicaje: '', Transporte: '', Apoyo: "", Tipo_Entrega: '',
            Ubicacion_Id: '', Correo: '', Suc_Factura: -1, Disponible_Positivo: false, DireccionAdic: '', sucFact: -1, Total: 0, ConDespacho: ''
        },
        esEcommerce: false, Despachar: false, DespacharLabel: 'Despachar', Imprimir: true, Eliminar: false, AnularDespacho: false, ordenGrupo: '', articulos: [], articulosAp: [], sucApoyo: [], filtro: '', mostrarDespacho: false,
        mapa: {
            location: { latitud: parseFloat(this.props.mapa.Latitud), longitud: parseFloat(this.props.mapa.Longitud) },
            option: { title: '', color: 'green', icon: ImagenesRutas.Ping }
        },
        articulosTotales: [],
        Estructura_Disponible_Orden: { Disponible: new Date(), Duracion: new Date(), Disponible_Positivo: false, Estatus_Suborden: 0, Estatus_subOrdenNombre: '' },
        parametrosGenerales: null,
        parametrosCadena: [],
        mostrarImpresion: false,
        articulosApImp: [], articulosImp: [], OrdenId: 0, intervalo: 0,
        cancelOrderCount: 0,
        procesandoEliminar: false,
        menuId: 0, menuOpciones: [], showModalSeguridad: false, opcionValidar: 0,
        habilitarBotonDespacho: true,
        showLotes: false,
        lstLotes: [],
        lstLotesSubOrden: [],
        lstLotesArticulo: [],
        sucursal_aplica_lotes: false,
        sucursal_factura_aplica_lotes: false,
        conexionLotes: {
            token: '',
            serviceUrl: ''
        },
        parametrosLotes: {
            empresa_id: 1,
            sucursal_id: 1,
            bodega_id: 1,
            modulo_id: 208,
            menu_id: 0,
            tipo_accion: 'salida',
            cantidad_requerida: 2,
            cantidad_decimales: 3,
            modo_consulta: false
        },
        articuloLotes: {
            Articulo_Id: '',
            Codigo_Principal: '',
            Nombre: '',
            Articulo_Dias_Vence: 0,
            Articulo_Vence: true,
            Decimales: true
        },
        showModalValidarLotes: false,
        lotes_validar: [],
        modalTitleSeguridad: null,
        despachoEditable: true,
        validarArticuloDespacho: false
    }

    componentDidMount = async () => {
        this._isMounted = true;
        this.initMonitorSucursales();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.stopInterval();
    }

    initMonitorSucursales = async () => {
        localStorageObject.set("UID", 0);
        localStorageObject.remove("USR");
        this.obtenerEstadoActiveDirectory();

        let mensajeVA = '';
        if (this.props.callCenter.Id <= 0) {
            mensajeVA = 'No se ha seleccionado un call center en los parámetros';
        }
        if (this.props.sucursal.Id <= 0) {
            if (mensajeVA.length > 0) {
                mensajeVA = 'No se ha seleccionado ni un call center y ni una sucursal en los parámetros';
            } else {
                mensajeVA = 'No se ha seleccionado una sucursal en los parámetros';
            }
        }

        if (mensajeVA.length > 0) {
            Notificacion.error(mensajeVA);
            this.props.history.replace(SiteRutas.Home);
            return false;
        }

        //verifica la URL de Ecommece
        const parametrosCadena = await this.cargarParametrosCadena();
        if (!parametrosCadena.Url_Servicio_eCommerce || parametrosCadena.Url_Servicio_eCommerce.trim().length === 0) {
            Notificacion.error('No se ha parametrizado la ruta del servicio ecommerce');
            this.props.history.replace(SiteRutas.Home);
            return false;
        }

        let menuId = 0;
        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        let menuOpciones = null;
        if (menuId > 0) {
            let response = await Obtener_MenuOpciones(this.props.token, menuId);
            if (response.Exitoso) {
                menuOpciones = response.Datos;
            } else {
                Notificacion.error(response.Mensaje);
            }
        }

        await this.cargarParametrosGenerales();

        const estadoOrdenes = `'${Config.c_Estatus_Operador}','${Config.c_Estatus_Despachada}','${Config.c_Estatus_Modificando}','${Config.c_Estatus_Venta}','${Config.c_Estatus_Impresa}','${Config.c_Estatus_Espera}','${Config.c_Estatus_Aseguradora}', '${Config.c_Estatus_Remesa}'`;
        const ParamCallCenter = await this.CargaParamCallCenter();

        let [fechaIni, fechaFin] = this.state.fecha_activa;
        if (ParamCallCenter.ParDiasCalendarizadas && ParamCallCenter.ParDiasCalendarizadas > 0) {
            fechaFin.setDate(fechaFin.getDate() + ParamCallCenter.ParDiasCalendarizadas);
        }

        const fecha_ini = moment.utc().year(fechaIni.getFullYear()).month(fechaIni.getMonth()).date(fechaIni.getDate()).startOf('day').toISOString();
        const fecha_fin = moment.utc().year(fechaFin.getFullYear()).month(fechaFin.getMonth()).date(fechaFin.getDate()).endOf('day').toISOString();

        let listaOrdenes = await this.cargaOrdenes(estadoOrdenes, fecha_ini, fecha_fin);
        let listaSubOrdenes = await this.cargaSubOrdenes();
        let listaOrdenesFiltradas = [...listaOrdenes];

        let intervalo = (ParamCallCenter.ParRefrescaMonitoreo * 1000);
        this.stopInterval();

        const mapa = {
            location: { latitud: parseFloat(this.props.mapa.Latitud), longitud: parseFloat(this.props.mapa.Longitud) },
            option: { title: '', color: 'green', icon: ImagenesRutas.Ping }
        };

        let parametrosLotes = { ...this.state.parametrosLotes };
        parametrosLotes.empresa_id = this.props.empresa.Id;
        parametrosLotes.sucursal_id = this.props.sucursal.Id;
        parametrosLotes.menu_id = menuId;

        this._isMounted && this.setState({
            listaOrdenes,
            listaOrdenesFiltradas,
            listaSubOrdenes,
            estadoOrdenes,
            intervalo,
            parametrosCadena,
            mapa,
            menuId,
            menuOpciones,
            parametrosLotes,
            cantDiasCalendarizados: ParamCallCenter.ParDiasCalendarizadas,
            permiteTrabajarCalendarizadas: ParamCallCenter.ParPermiteCalendarizadas,
            validarArticuloDespacho: ParamCallCenter.ValidarArticuloDespacho
        }, () => {
            this.startInterval(intervalo);
            this.buscar_parametro_sucursal_aplica_lotes();
        });
    }

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };

    startInterval = (pIntervalo) => {
        if (this.timer) {
            this.stopInterval();
        }

        this.timer = setInterval(() => {
            if (this.state.estadoOrdenes) {
                this._isMounted && this.cargarListaOrdenes();
            }
            else {
                this.stopInterval();
            }
        }, pIntervalo);
    }

    stopInterval = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    buscar_parametro_sucursal_aplica_lotes = async () => {
        if (this.props.token) {
            const response = await ObtieneParametroSucursal(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, 'Aplica_Lotes');
            if (response.Exitoso) {
                this.setState({ sucursal_aplica_lotes: response.Datos.valor === 'SI' });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
            }
        }
    }

    cargaOrdenes = async (pEstadoOrdenes, pFechaIni, pFechaFin) => {
        if (this.props.token) {

            //const estadoOrdenes = `'${Config.c_Estatus_Operador}','${Config.c_Estatus_Despachada}','${Config.c_Estatus_Modificando}','${Config.c_Estatus_Venta}','${Config.c_Estatus_Impresa}','${Config.c_Estatus_Espera}','${Config.c_Estatus_Aseguradora}','${Config.c_Estatus_Remesa}'`;
            const fecha_ini = moment.utc(pFechaIni).startOf('day').toISOString();
            const fecha_fin = moment.utc(pFechaFin).endOf('day').toISOString();

            const response = await Ordenes_Muestra_Despacho_RO(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.sucursal.Id, pEstadoOrdenes, fecha_ini, fecha_fin);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargaSubOrdenes = async () => {
        if (this.props.token) {

            const estadoOrdenes = `'${Config.c_Estatus_Operador}','${Config.c_Estatus_Despachada}','${Config.c_Estatus_Modificando}','${Config.c_Estatus_Venta}','${Config.c_Estatus_Impresa}','${Config.c_Estatus_Espera}','${Config.c_Estatus_Aseguradora}','${Config.c_Estatus_Remesa}'`;
            const response = await SubOrdenes_Muestra_Despacho_RO(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.sucursal.Id, estadoOrdenes);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    obtenerAnalisisTiempo = async (pOrden) => {
        if (this.props.token) {
            const response = await AnalisisTiempoOrden_Listar(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargarTiempos = async () => {
        if (this.props.token) {
            const response = await Tiempos_Lista(this.props.token, this.props.empresa.Id);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargar_Orden_Encabezado_Par_Detalle = async (pOrden) => {
        if (this.props.token) {
            const response = await Exp_Orden_Encabezado_Par_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargar_SubOrden_Detalle_Lotes = async (pOrden_Id) => {
        if (this.props.token) {
            const response = await Obtener_SubOrden_Detalles_Lote_Request(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, this.props.callCenter.Id, pOrden_Id);
            if (response.Exitoso) {
                this.setState({ lstLotesSubOrden: response.Datos, lstLotes: response.Datos });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
                this.setState({ lstLotesSubOrden: [] });
            }
        }
    }

    agregar_SubOrden_Detalle_Lotes = async (pOrden_Id, pLstLotes) => {
        if (this.props.token) {
            const response = await Agregar_SubOrden_Detalles_Lote_Request(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, this.props.callCenter.Id, pOrden_Id, pLstLotes);
            if (!response.Exitoso) {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    eliminar_SubOrden_Detalle_Lotes_Articulo = async (pOrden_Id, pArticulo_Id) => {
        if (this.props.token) {
            const response = await Eliminar_SubOrden_Detalles_Lote_Por_Articulo_Request(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, this.props.callCenter.Id, pOrden_Id, pArticulo_Id);
            if (!response.Exitoso) {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    cargar_Conexion_Lote = async () => {
        if (this.props.token) {
            const response = await Obtener_Conexion_Lote_Request(this.props.token);
            if (response.Exitoso) {
                this.setState({
                    conexionLotes: response.Datos
                });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    cargar_MovimientoInventario = async (pBodega, pMovId) => {
        if (this.props.token) {
            const response = await Movimiento_Inventario(this.props.token, this.props.empresa.Id, this.props.sucursal.Id, pBodega, 0, pMovId);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
                return {};
            }
        }
    }

    cargar_Suborden_Encabezado_Par_Listar = async (pOrden) => {
        if (this.props.token) {
            const response = await ExpSuborden_Encabezado_Par_Listar(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    CargaParamCallCenter = async () => {
        if (this.props.token) {
            const response = await ParametroCallCenter_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id);
            return response;
        }
    }

    cargarParametrosGenerales = async () => {
        if (this.props.token && !this.state.parametrosGenerales) {
            const response = await Listar_ParametrosGenerales(this.props.token);
            if (response.Exitoso) {
                this.setState({ parametrosGenerales: response.Datos });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    cargarParametrosCadena = async () => {
        if (this.props.token) {
            const response = await Listar_ParametrosCadena(this.props.token, this.props.empresa.Id, this.props.sucursal.Cadena);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
                return {};
            }
        }
    }

    cargarLotesArticulo = async () => {
        if (this.props.token) {
            const response = await Listar_ParametrosGenerales(this.props.token);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
                return {};
            }
        }
    }

    onClickOrdenes = async (pOrden) => {
        let _Orden = pOrden;
        const OrdenId = _Orden.Orden_Id;
        const esEcommerce = _Orden.Ecommerce;
        let Eliminar = false;
        let Despachar = _Orden.Estatus_id === Config.c_Estatus_Operador || _Orden.Estatus_id === Config.c_Estatus_Impresa || _Orden.Estatus_id === Config.c_Estatus_Venta || (this.state.permiteTrabajarCalendarizadas && _Orden.Estatus_id === Config.c_Estatus_Espera);
        if (pOrden.Suc_Factura == this.props.sucursal.Id) {
            Despachar = Despachar || _Orden.Estatus_id === Config.c_Estatus_Despachada || _Orden.Estatus_id === Config.c_Estatus_Aseguradora || _Orden.Estatus_id === Config.c_Estatus_Remesa;
            Eliminar = true;
        }

        const Imprimir = _Orden.Estatus_id !== Config.c_Estatus_Espera;
        const ordenGrupo = esEcommerce ? _Orden.Eco_Venta_Id : _Orden.Orden_Id;

        let ordenUbicacion = { ...this.state.ordenUbicacion };
        ordenUbicacion.Orden = _Orden.Orden_Id.toString();
        ordenUbicacion.Fecha = _Orden.fechaStr;
        ordenUbicacion.sucFact = pOrden.Suc_Factura;
        ordenUbicacion.Disponible = _Orden.Disponible;
        ordenUbicacion.Telefono = _Orden.Telefono;
        ordenUbicacion.Correo = _Orden.Correo;
        if (!_Orden.Ecommerce) {
            ordenUbicacion.Telefono = _Orden.Ubicacion_Id;
        }
        ordenUbicacion.Nombre = _Orden.Cliente_Nombre;
        ordenUbicacion.Coordenada = '';
        let Nivel1Nombre = _Orden.Nivel1_Nombre.toString().length > 0 ? ` ${_Orden.Nivel1_Nombre}, ` : '';
        let Nivel2Nombre = _Orden.Nivel2_Nombre.toString().length > 0 ? ` ${_Orden.Nivel2_Nombre}, ` : '';
        let Nivel3_Nombre = _Orden.Nivel3_Nombre.toString().length > 0 ? `${_Orden.Nivel3_Nombre}, ` : '';
        ordenUbicacion.Ubicacion = ` ${Nivel1Nombre} ${Nivel2Nombre} ${Nivel3_Nombre} ${_Orden.Nivel4_Nombre}`;
        ordenUbicacion.Localidad = _Orden.Tipo_Entrega === 'EX' ? (_Orden.Ubicacion_Localidad.length > 0 ? `${_Orden.Ubicacion_Localidad} : ${_Orden.Ubicacion_Num_Localidad} ` : _Orden.Ubicacion_Num_Localidad) : '';
        ordenUbicacion.DireccionAdic = `${_Orden.Ubicacion_Referencia} ${_Orden.Ubicacion_Direccion}`;
        ordenUbicacion.Observaciones = _Orden.Observaciones;
        ordenUbicacion.Peso = _Orden.PesoTotal;
        ordenUbicacion.Cubicaje = _Orden.CubicajeTotal;
        ordenUbicacion.Transporte = _Orden.TipoVehiculo;
        ordenUbicacion.Apoyo = _Orden.Apoyo;
        ordenUbicacion.Tipo_Entrega = _Orden.Tipo_Entrega;
        ordenUbicacion.Ubicacion_Id = _Orden.Ubicacion_Id;
        ordenUbicacion.Suc_Factura = _Orden.Suc_Factura;

        let listaSub = await this.cargar_Suborden_Encabezado_Par_Listar(pOrden.Orden_Id);
        const Estructura_Disponible_Orden = await this.Calcula_Diferencia_Orden(_Orden.Orden_Id, _Orden.Fec_Activar, listaSub, _Orden.Estatus_id);
        let segundos = ((Estructura_Disponible_Orden.Disponible.getTime() / 1000) - (new Date('1970/01/01').getTime() / 1000));
        ordenUbicacion.Disponible = toDDHHMMSS(segundos).join('');
        ordenUbicacion.Disponible_Positivo = Estructura_Disponible_Orden.Disponible_Positivo;
        ordenUbicacion.Estado = Estructura_Disponible_Orden.Estatus_subOrdenNombre;
        ordenUbicacion.Total = _Orden.Total;
        ordenUbicacion.ConDespacho = _Orden.Procesar_Orden_Parcial == 2 ? "Cliente NO permite despacho parcial. Solo pedido completo." : (_Orden.Procesar_Orden_Parcial == 1 ? "Cliente permite despacho parcial." : "");
        ordenUbicacion.Instrucciones_Entrega = _Orden.Instrucciones_Entrega;

        const AnularDespacho = Despachar && (_Orden.Estatus_id === Config.c_Estatus_Despachada ||
            _Orden.Estatus_id === Config.c_Estatus_Aseguradora ||
            _Orden.Estatus_id === Config.c_Estatus_Remesa ||
            Estructura_Disponible_Orden.Estatus_subOrdenNombre === 'Despacho');
        const DespacharLabel = AnularDespacho ? 'Eliminar' : 'Despachar';


        if (AnularDespacho) {
            this.setState({ lstLotesSubOrden: [] });
        }
        else {
            this.cargar_SubOrden_Detalle_Lotes(OrdenId);
            this.cargar_Conexion_Lote();
        }

        const _SucLog = this.props.sucursal.Id;
        const articulosTotales = await this.obtenerArticulos(pOrden.Orden_Id);
        const articulos = articulosTotales.filter((item) => item.Suc_Id == _SucLog);
        const articulosAp = articulosTotales.filter((item) => item.Suc_Id != _SucLog);

        if (articulos && articulos.length > 0 && articulos[0].Sucursal_Factura !== _SucLog && !this.state.sucursal_aplica_lotes) {

            const response = await ObtieneParametroSucursal(this.props.token, this.props.empresa.Id, articulos[0].Sucursal_Factura, 'Aplica_Lotes');
            if (response.Exitoso) {
                this.setState({ sucursal_factura_aplica_lotes: response.Datos.valor === 'SI' });
            }
        }

        const sucApoyo = [...new Set(articulosAp.map(x => x.Suc_Id))];

        const _Longitud = _Orden.Longitud == 0 ? parseFloat(this.props.mapa.Longitud) : _Orden.Longitud;
        const _Latitud = _Orden.Latitud == 0 ? parseFloat(this.props.mapa.Latitud) : _Orden.Latitud;
        const mapa = {
            location: { latitud: _Latitud, longitud: _Longitud },
            option: { title: `Orden: ${pOrden.Orden_Id.toString()}`, color: 'green', icon: ImagenesRutas.Ping }
        };

        let listaOrdenesFiltradas = this.state.listaOrdenesFiltradas;
        listaOrdenesFiltradas = this.seleccionarOrden(_Orden.Orden_Id, listaOrdenesFiltradas);

        this.setState({ esEcommerce, Despachar, Imprimir, Eliminar, OrdenId, ordenGrupo, ordenUbicacion, articulos, articulosAp, sucApoyo, mapa, articulosTotales, listaOrdenesFiltradas, DespacharLabel, AnularDespacho });
    }

    seleccionarOrden = (pOrden, plistaOrdenesFilradas) => {
        let listaOrdenes = plistaOrdenesFilradas;

        listaOrdenes.map(item => {
            item.Seleccionado = pOrden == item.Orden_Id;
        });

        return listaOrdenes;
    }

    onChangeFechaActiva = async (dates) => {
        const intervalo = this.state.intervalo;
        this.stopInterval();

        const [fechaIni, fechaFin] = dates;
        const fecha_activa_ini = moment.utc().year(fechaIni.getFullYear()).month(fechaIni.getMonth()).date(fechaIni.getDate()).startOf('day').toISOString();
        const fecha_activa_fin = moment.utc().year(fechaFin.getFullYear()).month(fechaFin.getMonth()).date(fechaFin.getDate()).endOf('day').toISOString();

        let listaOrdenes = await this.cargaOrdenes(this.state.estadoOrdenes, fecha_activa_ini, fecha_activa_fin);
        await this.cargaSubOrdenes();
        let listaOrdenesFiltradas = listaOrdenes;
        let filtro = '';
        let ordenUbicacion = this.inicializaOrdenSelect();

        const articulosTotales = [];
        const articulos = [];
        const articulosAp = [];

        const mapa = {
            location: { latitud: parseFloat(this.props.mapa.Latitud), longitud: parseFloat(this.props.mapa.Longitud) },
            option: { title: '', color: 'green', icon: ImagenesRutas.Ping }
        };

        this._isMounted && this.setState({
            fecha_activa: dates, listaOrdenesFiltradas, listaOrdenes,
            filtro, ordenUbicacion, articulosTotales, articulosAp, articulos, mapa
        }, () => this.startInterval(intervalo));
    }

    limpiarOrdenSeleccionada = () => {
        if (this.state.OrdenId != 0) {

            const ordenUbicacion = {
                Fecha: '', Orden: '', Estado: '', Disponible: '', Telefono: '', Nombre: '', coordenada: '', Ubicacion: '', Localidad: '', Observaciones: '', Peso: '', Cubicaje: '', Transporte: '', Apoyo: "", Tipo_Entrega: '',
                Ubicacion_Id: '', Correo: '', Suc_Factura: -1, Disponible_Positivo: false, DireccionAdic: '', sucFact: -1, Total: 0, ConDespacho: '', Instrucciones_Entrega: ''
            };
            const articulos = [], articulosAp = [], sucApoyo = [], OrdenId = 0;
            const mapa = {
                location: { latitud: parseFloat(this.props.mapa.Latitud), longitud: parseFloat(this.props.mapa.Longitud) },
                option: { title: '', color: 'green', icon: ImagenesRutas.Ping }
            };
            const Imprimir = false, Despachar = false;

            this.setState({ OrdenId, ordenUbicacion, articulos, articulosAp, sucApoyo, mapa, Imprimir, Despachar });
        }
    }

    cargarListaOrdenes = async () => {
        const intervalo = this.state.intervalo;
        this.stopInterval();

        const [fechaIni, fechaFin] = this.state.fecha_activa;
        let listaOrdenes = await this.cargaOrdenes(this.state.estadoOrdenes, fechaIni, fechaFin);
        let listaOrdenesFiltradas = listaOrdenes;
        const OrdenId = this.state.OrdenId;
        const ordenActual = listaOrdenes.filter(item => item.Orden_Id == OrdenId);
        const existeOrden = ordenActual && ordenActual.length > 0;
        if (!existeOrden || existeOrden.length === 0) {
            this.limpiarOrdenSeleccionada();
        }
        listaOrdenesFiltradas = this.seleccionarOrden(OrdenId, listaOrdenesFiltradas);
        let filtro = '';
        this._isMounted && this.setState({ listaOrdenesFiltradas, listaOrdenes, filtro }, () => this.startInterval(intervalo));
    }

    inicializaOrdenSelect = () => {
        return {
            Fecha: '', Orden: '', Estado: '', Disponible: '', Telefono: '', Nombre: '', coordenada: '', Ubicacion: '', Localidad: '',
            Observaciones: '', Peso: '', Cubicaje: '', Transporte: '', Apoyo: "", Tipo_Entrega: '', Ubicacion_Id: '', Correo: '', Suc_Factura: -1, Disponible_Positivo: false, DireccionAdic: '', sucFact: -1
        };
    }

    obtenerArticulos = async (pOrden) => {
        if (this.props.token) {
            const response = await Listar_Ordenes_A_Pantalla(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    filtraOrdenes = (filtro) => {
        let propiedades = { "Orden_Id": 0, "Cliente_Nombre": "" };
        let ordenesFiltradas = this.state.listaOrdenes.filter(orden => Object.keys(propiedades)
            .some(propiedad => orden[propiedad].toString().toLowerCase().includes(filtro.toLowerCase())));

        return ordenesFiltradas;
    }

    onChangeBuscar = event => {
        const filtro = event.target.value;
        const listaOrdenesFiltradas = this.filtraOrdenes(filtro);
        this.setState({ filtro, listaOrdenesFiltradas });
    }

    AsignarEstado_Imprimir = async () => {
        const ordenUbicacion = this.state.ordenUbicacion;
        const resultado = await Exp_Orden_Encabezado_Par_Imprime(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, ordenUbicacion.Orden, this.props.sucursal.Id);
        if (resultado.trim()) {
            Notificacion.error('Error: ' + resultado);
        }
    }

    agregar_Inventario_Detalle_Lotes = async (pBodega_Id, pMov_Id, pLstLotes, pUsuario) => {
        if (this.props.token && pLstLotes && pLstLotes.length > 0) {

            const { token, empresa, sucursal } = this.props;
            const response = await Agregar_Inventario_Detalles_Lote_Request(token, empresa.Id, sucursal.Id, pBodega_Id, pMov_Id, pLstLotes, pUsuario);
            if (!response.Exitoso) {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    Despachar_Orden = async () => {
        const { ordenUbicacion, articulosTotales, parametrosCadena, lstLotesSubOrden, articulos } = this.state;
        const artitulosDesp = articulosTotales.filter((item) => item.Suc_Id == this.props.sucursal.Id);

        let usuarioTemp = localStorageObject.get("UID");
        usuarioTemp = usuarioTemp ? usuarioTemp : 0;
        let resultado = await Exp_Despachar_Orden_Ecommerce(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, ordenUbicacion.Orden, this.props.sucursal.Id, JSON.stringify(artitulosDesp), parametrosCadena.Url_Servicio_eCommerce, usuarioTemp);
        if (resultado.trim()) {
            Notificacion.error('Error: ' + resultado);
        }
        else {
            if (ordenUbicacion.sucFact !== this.props.sucursal.Id && articulos[0].Mov_Id > 0) {
                this.agregar_Inventario_Detalle_Lotes(articulos[0].Suborden_Mov_Bodega, articulos[0].Mov_Id, lstLotesSubOrden, usuarioTemp);
            }
        }
    }

    Validar_Despacho_Orden_Ecommerce = async (pArticulosTotales) => {
        let _Valido = true;
        const ordenUbicacion = this.state.ordenUbicacion;
        const artitulosDesp = pArticulosTotales.filter((item) => item.Suc_Id == this.props.sucursal.Id);

        let resultado = await Exp_Validar_Despacho_Orden_Ecommerce(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, ordenUbicacion.Orden, this.props.sucursal.Id, JSON.stringify(artitulosDesp), false);
        if (!isNaN(resultado)) {
            let _Mens = parseInt(resultado);
            switch (_Mens) {
                case 1:
                    Notificacion.error('Debe elegir la opción de eliminar, porque no hay cantidades para facturar.');
                    _Valido = false;
                    break;
                case 2:
                    Notificacion.error('Existen sucursales de apoyo que aún no han terminado el proceso. Debe esperar o coordinar con ellas para determinar si la venta continúa o se elimina.');
                    _Valido = false;
                    break;
                case 3:
                    Notificacion.success('Las sucursales de apoyo han confirmado cantidades que pueden ser facturadas.');
                    _Valido = true;
                    break;
                case 4:
                    Notificacion.error('Debe elegir la opción eliminar, porque no hay cantidades para facturar.');
                    _Valido = false;
                    break;
                case 5:
                    Notificacion.error('No se puede confirmar la orden porque está incompleta. El cliente eligió solo aceptar el pedido si se factura completo.');
                    _Valido = false;
                    break;
                case 6:
                    Notificacion.error('El estado actual de la orden no permite despacho.');
                    _Valido = false;
                    break;
                default:
                    _Valido = true;
                    break;
            }
        } else {
            Notificacion.error('Error: ' + resultado);
            _Valido = false;
        }

        return _Valido;
    }

    Eliminar_Orden = async () => {
        this.setState({ procesandoEliminar: true });
        const ordenUbicacion = this.state.ordenUbicacion;
        const Valida_Estatus = await this.Valida_Estatus_Orden(ordenUbicacion.Orden);
        if (Valida_Estatus) {
            Swal.fire({
                title: "Eliminar Orden",
                html: "<h4>¿Desea eliminar esta orden de compra?</h4>" +
                    "<br /><div class='form-group'><label for='txtMotivo' style='float: left;'>Motivo</label>" +
                    "<textarea id='txtMotivo' class='form-control' cols='25' rows='4' spellCheck='true' maxLength='100' " +
                    "placeholder='Escriba su motivo aquí...' style='resize: none;'></textarea></div>",
                showCancelButton: true,
                confirmButtonText: "<h5>Sí</h5>",
                cancelButtonText: "<h5>No</h5>",
                reverseButtons: true,
                allowOutsideClick: false,
                preConfirm: () => {
                    const motivo = document.getElementById("txtMotivo").value.trim();
                    if (motivo && motivo.length <= 100) {
                        return motivo;
                    }
                    else {
                        Notificacion.error("Debe ingresar un motivo de anulación, entre 1 y 100 caracteres.");
                        return false;
                    }
                },
            }).then((result) => {

                if (result.value) {
                    this.Verifica_Estados_Orden(ordenUbicacion.Orden, result.value);
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    this.setState({ procesandoEliminar: false });
                }
            });
        }
        else {
            this.setState({ procesandoEliminar: false });
        }
    }

    anular_orden_credomatic = async (pBitacora) => {

        const respuesta = await Obtener_Autorizador_Tarjeta(this.props.token, this.props.empresa.Id, pBitacora.Autorizador_Id, pBitacora.Operacion_Id);
        if (respuesta.Exitoso) {

            switch (respuesta.Datos.Autorizador_Tipo) {
                case AUTHORIZE_TYPES.CREDOMATIC_CARDINAL:
                    this.cancelTransactionCardinal(pBitacora, respuesta.Datos);
                    break;
                case AUTHORIZE_TYPES.CREDOMATIC_FAC:
                    this.cancelTransactionFAC(pBitacora, respuesta.Datos);
                    break;
                case AUTHORIZE_TYPES.CREDOMATIC_FAC_3DS:
                    this.cancelTransactionFAC2(pBitacora, respuesta.Datos);
                    break;
                default:
                    this.setState({ procesandoEliminar: false });
                    Notificacion.error("Error: No se encontró la información requerida para la anulación de la transacción.");
                    break;
            }
        }
        else {
            if (respuesta.CodigoError === 2) {
                Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                this.props.history.replace(SiteRutas.Login);
                return;
            }
            this.setState({ procesandoEliminar: false });
            Notificacion.error(respuesta.Mensaje);
        }
    }

    cancelTransactionCardinal = (pBitacora, pAutorizador) => {

        if (pAutorizador.Autorizador_URL && pAutorizador.Autorizador_Key) {

            const bitacora = { ...pBitacora, Amount: pBitacora.Amount.toFixed(2), Empresa_Id: this.props.empresa.Id };
            this.Registrar_Bitacora_Credomatic(bitacora);
            return;
        }

        this.setState({ procesandoEliminar: false });
        Notificacion.error("Error: No se encontró la información requerida para la anulación de la transacción.");
    }

    cancelTransactionFAC = async (pBitacora, pAutorizador) => {

        if (pAutorizador.Autorizador_URL && pAutorizador.Autorizador_Key && pAutorizador.Autorizador_Key_Id && pAutorizador.Terminal && pBitacora.Order_Id) {

            const transaction = {
                Autorizador_Id: pBitacora.Autorizador_Id,
                Autorizador_Key: pAutorizador.Autorizador_Key,
                Autorizador_Key_Id: pAutorizador.Autorizador_Key_Id,
                Autorizador_URL: pAutorizador.Autorizador_URL,
                Tarjeta_Operacion_Id: pBitacora.Operacion_Id,
                Tarjeta_Operacion_Terminal: pAutorizador.Terminal,
                Amount: pBitacora.Amount,
                OrderNumber: pBitacora.Order_Id,
                Transaction_Id: pBitacora.Transaction_Id,
                Version: 1
            };

            const response = await ReversalFACRequest(this.props.token, transaction);
            if (response.Exitoso) {
                Notificacion.success('Se eliminó la orden con éxito.');
                this.setState({ procesandoEliminar: false });
                return;
            }
            else {
                this.setState({ procesandoEliminar: false });
                Swal.fire({
                    title: 'Anulación del pago',
                    icon: 'info',
                    html: 'La orden ha sido anulada pero no ha sido posible obtener respuesta de la entidad financiera que procesó la tarjeta. Debe tramitar la reversión sobre la tarjeta de crédito para esta orden usando la interfaz suministrada por la entidad financiera.'
                });
                return;
            }
        }

        this.setState({ procesandoEliminar: false });
        Notificacion.error("Error: No se encontró la información requerida para la anulación de la transacción.");
    }

    cancelTransactionFAC2 = async (pBitacora, pAutorizador) => {
        if (pAutorizador.Autorizador_URL && pAutorizador.Autorizador_Key && pAutorizador.Terminal && pBitacora.Order_Id) {

            const transaction = {
                Autorizador_Id: pBitacora.Autorizador_Id,
                Autorizador_Key: pAutorizador.Autorizador_Key,
                Autorizador_URL: pAutorizador.Autorizador_URL,
                Tarjeta_Operacion_Id: pBitacora.Operacion_Id,
                Tarjeta_Operacion_Terminal: pAutorizador.Terminal,
                Amount: pBitacora.Amount,
                OrderNumber: pBitacora.Order_Id,
                Transaction_Identifier: pBitacora.Guid_Interfaz,
                Version: 2
            };

            const response = await ReversalFACRequest(this.props.token, transaction);
            if (response.Exitoso) {
                Notificacion.success('Se eliminó la orden con éxito.');
                this.setState({ procesandoEliminar: false });
                return;
            }
            else {
                this.setState({ procesandoEliminar: false });
                Swal.fire({
                    title: 'Anulación del pago',
                    icon: 'info',
                    html: 'La orden ha sido anulada pero no ha sido posible obtener respuesta de la entidad financiera que procesó la tarjeta. Debe tramitar la reversión sobre la tarjeta de crédito para esta orden usando la interfaz suministrada por la entidad financiera.'
                });
                return;
            }
        }

        this.setState({ procesandoEliminar: false });
        Notificacion.error("Error: No se encontró la información requerida para la anulación de la transacción.");
    }

    Registrar_Bitacora_Credomatic = async (pBitacora) => {
        const response = await Registrar_Bitacora_Credomatic_Request(this.props.token, pBitacora);
        if (response.Exitoso) {
            this.validateResponse(response.Datos, pBitacora);
        }
        else {
            if (response.CodigoError === 2) {
                Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                this.props.history.replace(SiteRutas.Login);
                return;
            }
            Notificacion.error('Error: ' + response.Mensaje);
            this.setState({ procesandoEliminar: false });
        }
    }

    Actualizar_Bitacora_Credomatic = async (response, pBitacora) => {

        const bitacora = {
            Type: 'void',
            Hash: response.hash,
            Time: response.time,
            Response: response.response,
            Response_Text: `text=${response.responsetext}&avs=${response.avsresponse}&cvv=${response.cvvresponse}`,
            Response_Code: response.response_code,
            Auth_Code: response.authcode,
            Transaction_Id: response.transactionid ? response.transactionid : pBitacora.Transaction_Id,
            Order_Id: response.orderid ? response.orderid : pBitacora.Order_Id
        };

        Actualizar_Bitacora_Credomatic_Request(this.props.token, bitacora);
    }

    Borra_Orden = async (pOrden, pMotivoAnulacion) => {
        let usuarioAuth = localStorageObject.get("USR");
        usuarioAuth = usuarioAuth ? usuarioAuth : "";

        let resultado = await Eliminar_Orden_Completo_Orden(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden, usuarioAuth, pMotivoAnulacion);
        if (resultado.trim().length === 0) {

            let anulacionCredomatic = false;
            const referencias = await Obtener_Pago_Referencias_Tarjetas(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (referencias.Exitoso) {
                if (referencias.Datos && referencias.Datos.length > 0) {

                    for (let index = 0; index < referencias.Datos.length; index++) {

                        if (referencias.Datos[index].Autorizador_Id && (referencias.Datos[index].Transaccion_Id || referencias.Datos[index].Pago_Guid_Interfaz)) {
                            anulacionCredomatic = true;
                            const bitacora = {
                                Autorizador_Id: referencias.Datos[index].Autorizador_Id,
                                Operacion_Id: referencias.Datos[index].Operacion_Id,
                                Type: 'void',
                                Transaction_Id: referencias.Datos[index].Transaccion_Id,
                                Amount: referencias.Datos[index].Pago_Total,
                                Order_Id: referencias.Datos[index].Pago_Orden_Id_Interfaz,
                                Guid_Interfaz: referencias.Datos[index].Pago_Guid_Interfaz
                            };
                            this.anular_orden_credomatic(bitacora);
                        }
                    }
                }
            }
            else {
                if (referencias.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error('Error: ' + referencias.Mensaje);
                this.setState({ procesandoEliminar: false });
            }

            if (referencias.Exitoso && !anulacionCredomatic) {
                Notificacion.success('Se eliminó la orden con éxito.');
                this.setState({ procesandoEliminar: false });
            }
        }
        else {
            Notificacion.error('Error: ' + resultado);
            this.setState({ procesandoEliminar: false });
        }
        const [fechaIni, fechaFin] = this.state.fecha_activa;
        await this.onChangeFechaActiva([new Date(fechaIni), new Date(fechaFin)]);
        this.setState({ mostrarDespacho: false });
    }

    Verifica_Estados_Orden = async (pOrden, pMotivoAnulacion) => {
        let _resultado = false;
        const MsjMovAplicados = await Verifica_Movimientos_Aplicados_Orden(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
        if (MsjMovAplicados) {
            if (MsjMovAplicados.substring(0, 5) === "ERROR") {
                Notificacion.error("Eliminar Orden", "Se ha presentado un error al eliminar." + MsjMovAplicados);
                this.setState({ procesandoEliminar: false });
                _resultado = false;
            } else {
                Swal.fire({
                    title: "Eliminar Orden",
                    html: "<h4>¿Está seguro de querer eliminar esta orden, a pesar de que ya tiene movimientos aplicados?</h4>",
                    showCancelButton: true,
                    confirmButtonText: "<h5>Sí</h5>",
                    cancelButtonText: "<h5>No</h5>",
                    reverseButtons: true,
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {
                        this.Borra_Orden(pOrden, pMotivoAnulacion);
                        _resultado = true;
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        this.setState({ procesandoEliminar: false });
                        _resultado = false;
                    }
                });
            }
        } else {
            await this.Borra_Orden(pOrden, pMotivoAnulacion);
            _resultado = true;
        }
        return _resultado;
    }

    Valida_Estatus_Orden = async (pOrden) => {
        let _Continua_Estatus = false;
        //await this.obtenerAnalisisTiempo(pOrden);
        let _Orden_Encabezado_Par_Detalle = await this.cargar_Orden_Encabezado_Par_Detalle(pOrden);
        const _Estado_Actual = _Orden_Encabezado_Par_Detalle.Estatus_id;

        if ((_Estado_Actual === Config.c_Estatus_Modificando) || (_Estado_Actual === Config.c_Estatus_Facturada) || (_Estado_Actual === Config.c_Estatus_Ruta) || (_Estado_Actual === Config.c_Estatus_Terminada) ||
            (_Estado_Actual === Config.c_Estatus_Borrada) || (_Estado_Actual === Config.c_Estatus_Pospuesta)) {

            Notificacion.error("No se puede borrar esta orden ya que se encuentra en estado de: " + Retorna_Nombre_Estado_Orden(_Estado_Actual));
            _Continua_Estatus = false;
        } else {
            _Continua_Estatus = true;
        }
        return _Continua_Estatus;
    }

    validar_vencimiento_lotes = () => {

        const { articulosTotales, sucursal_aplica_lotes, sucursal_factura_aplica_lotes, lstLotes, menuOpciones } = this.state;

        if ((sucursal_aplica_lotes || sucursal_factura_aplica_lotes) && lstLotes && lstLotes.length > 0) {

            let existe_lote_vencido = lstLotes.some(lote => {
                if (lote.Vence) {
                    const fecha_vence = moment(lote.Fecha_Vencimiento);
                    const fecha_actual = moment();
                    const dias_vencer = fecha_vence.diff(fecha_actual, 'days');
                    return dias_vencer < 0;
                }
                else {
                    return false;
                }
            });

            if (existe_lote_vencido) {
                Notificacion.error("No se puede continuar, ya que existen lotes vencidos.");
                this.setState({ habilitarBotonDespacho: true });
                return false;
            }

            let resultado = menuOpciones.filter(item => item.Opcion_Id === Config.m_Despachar_Lotes_Vencidos);
            if (resultado.length > 0) {
                if (resultado[0].Validar) {

                    let proximo_a_vencer = false;

                    lstLotes.every(lote => {
                        if (lote.Vence) {

                            const articulos = articulosTotales.filter((item) => item.Articulo_Id == lote.Articulo_Id);
                            proximo_a_vencer = moment(lote.Fecha_Vencimiento) <= moment().add(articulos[0].Articulo_Dias_Vence, 'days');
                            return !proximo_a_vencer;
                        }
                        return true;
                    });

                    if (proximo_a_vencer) {

                        this.setState({ modalTitleSeguridad: 'Lote Próximo a Vencer' });
                        let validar = this.validarMenuOpcion(Config.m_Despachar_Lotes_Vencidos);
                        if (!validar) {
                            this.despachar_orden_metodo();
                        }
                        return;
                    }
                }
            }
        }
        this.despachar_orden_metodo();
    }

    //modal
    onClickDespachoOrdenHandler = async () => {
        const articulosTotales = this.state.articulosTotales;
        if (articulosTotales.length > 0) {
            if (this.state.Despachar) {
                if (this.state.mostrarDespacho) {
                    if (!this.state.AnularDespacho) {
                        this.setState({ habilitarBotonDespacho: false });
                        let validar = this.validarMenuOpcion(Config.m_Despachar_Orden);
                        if (!validar) {
                            this.validar_vencimiento_lotes();
                        }
                    }
                }
                else {
                    const ordenUbicacion = this.state.ordenUbicacion;
                    let editable = true;
                    const AnularDespacho = this.state.AnularDespacho;
                    if (this.props.sucursal.Id != ordenUbicacion.sucFact) {
                        const articulos = this.state.articulos;
                        const _Mov = await this.cargar_MovimientoInventario(articulos[0].Suborden_Mov_Bodega, articulos[0].Mov_Id);
                        editable = AnularDespacho ? false : _Mov.Estado === "GU";
                    } else {
                        editable = AnularDespacho ? false : editable;
                    }

                    this.setState({ mostrarDespacho: true, despachoEditable: editable, habilitarBotonDespacho: true });
                }
            }
        } else {
            Notificacion.error("No ha seleccionado una orden");
        }
    }

    despachar_orden_metodo = async () => {
        const { articulosTotales, sucursal_aplica_lotes, sucursal_factura_aplica_lotes, lstLotes } = this.state;

        if (sucursal_aplica_lotes || sucursal_factura_aplica_lotes) {

            let lotes_no_validos = [];

            const articulosDesp = articulosTotales.filter(item => item.Suc_Id == this.props.sucursal.Id);
            articulosDesp.forEach(articulo => {
                if (articulo.Aplica_Lote) {
                    let cantidad_lotes = 0;

                    const lotesArticulo = lstLotes.filter(lote => lote.Articulo_Id === articulo.Articulo_Id);
                    if (lotesArticulo && lotesArticulo.length > 0) {
                        cantidad_lotes = lotesArticulo.reduce((a, b) => a + (parseFloat(b['Cantidad'] || 0)), 0);
                    }

                    if (cantidad_lotes !== parseFloat(articulo.Detalle_Facturar)) {
                        lotes_no_validos.push({ ...articulo, Cant_Lotes: cantidad_lotes });
                    }
                }
            });

            if (lotes_no_validos.length > 0) {
                this.setState({ showModalValidarLotes: true, lotes_validar: lotes_no_validos, habilitarBotonDespacho: true });
                return false;
            }
        }

        const _despachar = await this.Validar_Despacho_Orden_Ecommerce(articulosTotales);
        if (_despachar) {
            await this.Despachar_Orden();
            Notificacion.success("Despacho exitoso");
        }
        const [fechaIni, fechaFin] = this.state.fecha_activa;
        await this.onChangeFechaActiva([new Date(fechaIni), new Date(fechaFin)]);
        this.setState({ mostrarDespacho: false });
    }

    establecer_articulo_validado = (pArticulo_Id) => {
        let articulosTotales = [...this.state.articulosTotales];
        if (articulosTotales && articulosTotales.length > 0) {

            const index = articulosTotales.findIndex(item => item.Articulo_Id === pArticulo_Id);
            if (index >= 0) {
                articulosTotales[index].Detalle_Articulo_Validado = true;
                this._isMounted && this.setState({ articulosTotales });
            }
        }
    }

    onClickEliminar = async () => {
        if (this.state.Eliminar && this.state.mostrarDespacho && !this.state.procesandoEliminar) {
            let validar = this.validarMenuOpcion(Config.m_Eliminar_Orden);
            if (!validar) {
                this.Eliminar_Orden();
            }
        }
    }

    onClickImprimirHandler = async () => {
        const articulosTotales = this.state.articulosTotales;
        if (articulosTotales.length > 0) {
            if (this.state.Imprimir) {

                let validar = this.validarMenuOpcion(Config.m_Imprimir_Orden);
                if (!validar) {
                    this.imprimir_orden();
                }
            }
        } else {
            Notificacion.error("No ha seleccionado una orden");
        }
    }

    imprimir_orden = async () => {
        await this.AsignarEstado_Imprimir();
        await this.impresion();
    }

    onClickCancelar = () => {
        this.setState({ mostrarDespacho: false });
    }

    impresion = async () => {
        const articulosTotales = this.state.articulosTotales;
        let Estructura_Disponible_Orden = this.state.Estructura_Disponible_Orden;
        const ordenUbicacion = this.state.ordenUbicacion;

        let _Orden_Encabezado_Par_Detalle = await this.cargar_Orden_Encabezado_Par_Detalle(ordenUbicacion.Orden);
        let _Suborden_Encabezado_Par_Listar = await this.cargar_Suborden_Encabezado_Par_Listar(ordenUbicacion.Orden);

        Estructura_Disponible_Orden = await this.Calcula_Diferencia_Orden(_Orden_Encabezado_Par_Detalle.Orden_Id, _Orden_Encabezado_Par_Detalle.Fec_Activar, _Suborden_Encabezado_Par_Listar, _Orden_Encabezado_Par_Detalle.Estatus_Id);

        let SucImp = this.props.sucursal.Id;
        let articulosImp = articulosTotales.filter((item) => item.Suc_Id == SucImp)
        if (articulosImp.length === 0) {
            if (articulosTotales.length > 0) {
                SucImp = articulosTotales[0].Suc_Id;
                articulosImp = articulosTotales.filter((item) => item.Suc_Id == SucImp);
            }
        }

        const articulosApImp = articulosTotales.filter((item) => item.Suc_Id != SucImp);
        const sucApoyo = [...new Set(articulosApImp.map(x => x.Suc_Id))];
        const mostrarImpresion = true;

        this.setState({ articulosImp, articulosApImp, sucApoyo, SucImp, mostrarImpresion, Estructura_Disponible_Orden });
    }

    onClickCancelarImp = async () => {
        //const [fechaIni, fechaFin] = this.state.fecha_activa;
        //await this.onChangeFechaActiva([new Date(fechaIni), new Date(fechaFin)]);
        this.setState({ ordenUbicacion: { ...this.state.ordenUbicacion, Estado: 'Impresa' }, mostrarImpresion: false });
    }

    Calcula_Diferencia_Orden = async (pOrden, pOrden_Fec_Activar, pExp_Encabezado_Suborden, pEstatus, _Estructura_Disponible_Orden) => {
        let _Registro_Suborden = {};
        let _Estatus_Suborden = "";
        let _Duracion = new Date("1970/01/01");
        let _Disponible = new Date("1970/01/01");
        let _Disponible_Positivo = false;
        let _Retorna_Estructura = this.state.Estructura_Disponible_Orden;
        let _Fecha_Hora_Actual = Date();
        let _Orden_Fec_Activar = new Date(pOrden_Fec_Activar);
        let _ListaTiempo = [];
        let _Tiempo_Orden = new Date("1970/01/01");
        let _Tiempo_Despacho = new Date("1970/01/01");
        let _Suborden_Fec_Despacho = new Date("1970/01/01");
        let _Maximo = [];
        _ListaTiempo = await this.cargarTiempos();
        _ListaTiempo.map((item) => {
            if (item.Estatus_Id === Config.c_Estatus_Operador || item.Estatus_id === Config.c_Estatus_Impresa) {
                _Maximo = item.MaximoStr.split(':');
                _Tiempo_Orden = new Date('1970/01/01 ' + _Maximo[1] + ':' + _Maximo[2] + ':00');
            }

            if (item.Estatus_Id === Config.c_Estatus_Despachada) {
                _Maximo = item.MaximoStr.split(':');
                _Tiempo_Despacho = new Date('1970/01/01 ' + _Maximo[1] + ':' + _Maximo[2] + ':00');
            }
        });

        _Fecha_Hora_Actual = new Date();
        _Registro_Suborden = pExp_Encabezado_Suborden.filter((item) => item.Suc_Id == this.props.sucursal.Id && item.Orden_Id == pOrden);
        _Estatus_Suborden = _Registro_Suborden[0].Estatus_Id;
        _Suborden_Fec_Despacho = new Date(_Registro_Suborden[0].Fec_Despacho);

        if ((_Registro_Suborden[0].Estatus_Id === Config.c_Estatus_Operador) || (_Registro_Suborden[0].Estatus_Id === Config.c_Estatus_Impresa)) {
            _Duracion.setSeconds(Math.abs(((_Orden_Fec_Activar.getTime() - _Fecha_Hora_Actual.getTime()) / 1000)));

            if ((pEstatus === Config.c_Estatus_Operador) || (pEstatus === Config.c_Estatus_Impresa)) {
                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Orden.getTime()) / 1000)));

            } else {

                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Despacho.getTime()) / 1000)));
            }
        } else if (_Registro_Suborden[0].Estatus_Id === Config.c_Estatus_Despachada) {

            _Duracion.setSeconds(Math.abs(((_Suborden_Fec_Despacho.getTime() - _Fecha_Hora_Actual.getTime()) / 1000)));
            if ((pEstatus === Config.c_Estatus_Operador) || (pEstatus === Config.c_Estatus_Impresa)) {
                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Orden.getTime()) / 1000)));

            } else {
                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Despacho.getTime()) / 1000)));
            }
        }

        if ((pEstatus === Config.c_Estatus_Operador) || (pEstatus === Config.c_Estatus_Impresa)) {
            _Disponible_Positivo = ((_Tiempo_Orden.getTime() - _Duracion.getTime()) / 1000) >= 0;
        } else {
            _Disponible_Positivo = false;
        }

        _Retorna_Estructura.Disponible = _Disponible;
        _Retorna_Estructura.Duracion = _Duracion;
        _Retorna_Estructura.Disponible_Positivo = _Disponible_Positivo;
        _Retorna_Estructura.Estatus_Suborden = _Estatus_Suborden;
        _Retorna_Estructura.Estatus_subOrdenNombre = _Registro_Suborden[0].EstatusNombre;
        return _Retorna_Estructura;
    }

    validateResponse = (response, pBitacora) => {
        if (!response || !response.response) {
            this.setState({ procesandoEliminar: false });
            return;
        }

        this.Actualizar_Bitacora_Credomatic(response, pBitacora);

        if (response.response === '1' && response.response_code === '100') { //Transaccion Aprobada
            Notificacion.success('Se eliminó la orden con éxito.');
            this.setState({ procesandoEliminar: false });
        }
        else {
            this.setState({ procesandoEliminar: false });
            Swal.fire({
                title: 'Anulación del pago',
                icon: 'info',
                html: 'La orden ha sido anulada pero no ha sido posible obtener respuesta de la entidad financiera que procesó la tarjeta. Debe tramitar la reversión sobre la tarjeta de crédito para esta orden usando la interfaz suministrada por la entidad financiera.'
            });
        }
    }

    /* Modal Seguridad */
    validarMenuOpcion = opcionId => {
        let validar = false;
        let menuOpciones = this.state.menuOpciones;

        let resultado = menuOpciones.filter(item => item.Opcion_Id === opcionId);
        if (resultado.length > 0) {
            if (resultado[0].Validar) {
                this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id, });
                validar = true;
            }
        } else {
            this.setState({ showModalSeguridad: true, opcionValidar: opcionId });
            validar = true;
        }

        return validar;
    };

    onActionResultModal = (pValido) => {
        if (pValido) {
            const opcionValidar = this.state.opcionValidar;

            this.setState({ showModalSeguridad: false, opcionValidar: 0 });
            switch (opcionValidar) {
                case Config.m_Eliminar_Orden:
                    this.Eliminar_Orden(this.submitVoidBtn);
                    break;
                case Config.m_Despachar_Orden:
                    this.validar_vencimiento_lotes();
                    break;
                case Config.m_Imprimir_Orden:
                    this.imprimir_orden();
                    break;
                case Config.m_Despachar_Lotes_Vencidos:
                    this.setState({ modalTitleSeguridad: null });
                    this.despachar_orden_metodo();
                    break;
                default:
                    break;
            }
        }
    }

    handleCerrarModal = () => this.setState({ showModalSeguridad: false, habilitarBotonDespacho: true });

    onClickLotes = async (row) => {

        let parametrosLotes = { ...this.state.parametrosLotes };
        parametrosLotes.cantidad_requerida = row.Detalle_Facturar;
        parametrosLotes.bodega_id = row.Bodega_Id;
        parametrosLotes.cantidad_decimales = this.state.parametrosGenerales.Maximo_Decimales_Articulo_Cantidad;

        let articuloLotes = { ...this.state.articuloLotes };
        articuloLotes.Articulo_Id = row.Articulo_Id;
        articuloLotes.Codigo_Principal = row.Articulo_Codigo_Principal;
        articuloLotes.Nombre = row.Articulo_Nombre;
        articuloLotes.Articulo_Dias_Vence = row.Articulo_Dias_Vence;
        articuloLotes.Articulo_Vence = row.Articulo_Vence;
        articuloLotes.Decimales = row.Articulo_Decimales;

        let lstLotesSubOrden = [...this.state.lstLotesSubOrden];
        const lstLotesArticulo = lstLotesSubOrden.filter(lote => lote.Articulo_Id === row.Articulo_Id);

        this.setState({ parametrosLotes, articuloLotes, showLotes: true, lstLotesArticulo });
    }

    onCloseLotes = (pLstLotes, pHasChanges) => {
        let lstLotes = [...this.state.lstLotes];
        lstLotes = lstLotes.filter(lote => lote.Articulo_Id !== this.state.articuloLotes.Articulo_Id);

        let lstLotesSubOrden = this.state.lstLotesSubOrden.filter(lote => lote.Articulo_Id !== this.state.articuloLotes.Articulo_Id);

        if (pLstLotes && pLstLotes.length > 0) {
            lstLotes = [...lstLotes, ...pLstLotes];
            lstLotesSubOrden = [...lstLotesSubOrden, ...pLstLotes];
            pHasChanges && this.agregar_SubOrden_Detalle_Lotes(this.state.ordenUbicacion.Orden, pLstLotes);
        }
        else {
            pHasChanges && this.eliminar_SubOrden_Detalle_Lotes_Articulo(this.state.ordenUbicacion.Orden, this.state.articuloLotes.Articulo_Id);
        }

        // Actualizar lista lotes no validos
        let lotes_no_validos = [...this.state.lotes_validar];
        if (lotes_no_validos && lotes_no_validos.length > 0) {

            const indexLote = lotes_no_validos.findIndex(lote => lote.Articulo_Id === this.state.articuloLotes.Articulo_Id);
            if (indexLote > -1) {

                let cantidad_lotes = 0;

                const lotesArticulo = lstLotes.filter(lote => lote.Articulo_Id === this.state.articuloLotes.Articulo_Id);
                if (lotesArticulo && lotesArticulo.length > 0) {
                    cantidad_lotes = lotesArticulo.reduce((a, b) => a + (parseFloat(b['Cantidad'] || 0)), 0);
                }

                if (cantidad_lotes !== parseFloat(lotes_no_validos[indexLote].Detalle_Facturar)) {
                    lotes_no_validos[indexLote].Cant_Lotes = cantidad_lotes;
                }
                else {
                    lotes_no_validos.splice(indexLote, 1);
                }
            }
        }

        this.setState({ showLotes: false, lotes_validar: lotes_no_validos, lstLotes, lstLotesSubOrden });
    }

    onCloseModalValidarLotes = () => {
        this.setState({ showModalValidarLotes: false });
    }

    render() {
        const { listaOrdenesFiltradas, ordenUbicacion, esEcommerce, Despachar, DespacharLabel, AnularDespacho, Eliminar, ordenGrupo, articulos, articulosAp,
            sucApoyo, mapa, mostrarDespacho, articulosTotales, filtro,
            SucImp, Estructura_Disponible_Orden, mostrarImpresion, articulosApImp, articulosImp, parametrosGenerales, OrdenId, Imprimir,
            procesandoEliminar, menuId, showModalSeguridad, opcionValidar, lstLotesArticulo, showLotes, showModalValidarLotes, lotes_validar, articuloLotes,
            parametrosLotes, conexionLotes, modalTitleSeguridad, cantDiasCalendarizados, despachoEditable, sucursal_factura_aplica_lotes, sucursal_aplica_lotes
        } = this.state;
        const _Disponible = toDDHHMMSS((Estructura_Disponible_Orden.Disponible.getTime() / 1000) - (new Date('1970/01/01').getTime() / 1000)).join('');
        const R_Disponible = _Disponible;

        const style = { color_primario: '#0b5ed7' };

        return (
            <Fragment>

                <MonitorSucursalInt
                    listaOrdenes={listaOrdenesFiltradas}
                    ordenUbicacion={ordenUbicacion}
                    esEcommerce={esEcommerce}
                    Despachar={Despachar}
                    DespacharLabel={DespacharLabel}
                    Imprimir={Imprimir}
                    ordenGrupo={ordenGrupo}
                    onClickOrdenes={this.onClickOrdenes}
                    articulos={articulos}
                    articulosAp={articulosAp}
                    sucApoyo={sucApoyo}
                    mapa={mapa}
                    onChangeBuscar={this.onChangeBuscar}
                    onChangeFechaActiva={this.onChangeFechaActiva}
                    onClickDespachoHandler={this.onClickDespachoOrdenHandler}
                    onClickImprimirHandler={this.onClickImprimirHandler}
                    filtro={filtro}
                    diasCalendarizados={cantDiasCalendarizados}
                />
                <DespacharOrdenes
                    show={mostrarDespacho}
                    onClick={this.onClickDespachoOrdenHandler}
                    onClickCancelar={this.onClickCancelar}
                    onClickEliminar={this.onClickEliminar}
                    onClickLotes={this.onClickLotes}
                    ordenUbicacion={ordenUbicacion}
                    articulosTotales={articulosTotales}
                    ordenGrupo={ordenGrupo}
                    Eliminar={Eliminar}
                    AnularDespacho={AnularDespacho}
                    procesandoEliminar={procesandoEliminar}
                    habilitarBotonDespacho={this.state.habilitarBotonDespacho}
                    validarArticulo={this.state.validarArticuloDespacho}
                    editable={despachoEditable}
                    aplicaLotes={sucursal_factura_aplica_lotes || sucursal_aplica_lotes}
                    parametrosGenerales={parametrosGenerales}
                    onSetValidacionArticulo={this.establecer_articulo_validado}
                />

                <ImprimeDespacho
                    show={mostrarImpresion}
                    sucApoyo={sucApoyo}
                    SucImp={SucImp}
                    sucFact={ordenUbicacion.Suc_Factura}
                    articulos={articulosImp}
                    articulosAp={articulosApImp}
                    tipoEntrega={ordenUbicacion.Tipo_Entrega}
                    onClickCancelar={this.onClickCancelarImp}
                    R_Disponible={R_Disponible}
                    Disponible_Positivo={Estructura_Disponible_Orden.Disponible_Positivo}
                    Re_Impreso={false}
                    ParametroGenerales={parametrosGenerales}
                    OrdenId={OrdenId}
                    empresa_nombre={this.props.empresa.Nombre}
                    instrucciones_entrega={ordenUbicacion.Instrucciones_Entrega}
                />

                <ModalSeguridad
                    token={this.props.token}
                    menuId={menuId}
                    opcionId={opcionValidar}
                    show={showModalSeguridad}
                    modalTitle={modalTitleSeguridad}
                    onActionResult={this.onActionResultModal}
                    onHide={this.handleCerrarModal}
                    activoAD={this.state.activoAD}
                />

                <ModalValidarLotes show={showModalValidarLotes} rows={lotes_validar} onClickLotes={this.onClickLotes} onClose={this.onCloseModalValidarLotes} />

                <LotesComponent show={showLotes} conexion={conexionLotes} parametros={parametrosLotes} articulo={articuloLotes} lstLotes={lstLotesArticulo} style={style} onClose={this.onCloseLotes} />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter,
        mapa: state.parametros.mapa
    };
};

export default connect(mapStateToProps)(withRouter(memo(MonitorSucursales)));
